// CTA URL builders + helpers for translating content-model entries into runtime
// href strings. Content model uses `cta_kind`: "external" | "whatsapp" | "email" | "anchor".

const encode = (text) => encodeURIComponent(text ?? "");

export const buildWhatsAppLink = (number, message) =>
    `https://wa.me/${(number || "").replace(/\D/g, "")}?text=${encode(message)}`;

export const buildMailLink = (email, subject, body) =>
    `mailto:${email}?subject=${encode(subject)}&body=${encode(body)}`;

/** Render a template string by replacing `{name}` placeholders. */
export const renderTemplate = (template, vars = {}) => {
    if (!template) return "";
    return template.replace(/\{(\w+)\}/g, (_, k) =>
        Object.prototype.hasOwnProperty.call(vars, k) ? String(vars[k] ?? "") : `{${k}}`,
    );
};

/**
 * Resolve a CTA entry to an href string using site contact settings.
 *
 * entry = { cta_kind, cta_url?, title? }
 * contact = content.contact
 * area    = optional area-of-interest label
 */
export const resolveCtaHref = (entry, contact, area = "") => {
    const kind = entry?.cta_kind || "external";
    switch (kind) {
        case "whatsapp":
            return buildWhatsAppLink(
                contact?.whatsapp_number,
                renderTemplate(contact?.whatsapp_template, { area: area || entry?.title || "" }),
            );
        case "resource_whatsapp":
            return buildWhatsAppLink(
                contact?.whatsapp_number,
                renderTemplate(contact?.resource_whatsapp_template, { resource: entry?.title || "" }),
            );
        case "email":
            return buildMailLink(
                contact?.email,
                contact?.email_subject,
                renderTemplate(contact?.email_template, { area: area || entry?.title || "" }),
            );
        case "anchor":
        case "external":
        default:
            return entry?.cta_url || "";
    }
};

/** Whether this CTA is an external/new-tab link (needs target=_blank). */
export const isExternalCta = (entry) => {
    const kind = entry?.cta_kind || "external";
    if (kind === "anchor") return false;
    if (kind === "external") return /^https?:/i.test(entry?.cta_url || "");
    return true; // whatsapp, resource_whatsapp, email → open in new tab
};
